<template>
  <div class="flex-center">
    <v-btn color="admin" dark outlined @click="onExport">
      <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import * as XLSX from 'xlsx'
import {saveAs} from 'file-saver'
import {get} from 'lodash'
export default {
  computed: {
    ...mapGetters('auth', ['user']),
  },
  methods: {
    ...mapActions({fetchCVsIndependent: 'cv/fetchCVsIndependent'}),
    renderCvStatus(val) {
      if (val === 'submitted') return 'Đã nộp'
      if (val === 'created') return 'Vừa tạo'
      if (val === 'disabled') return 'Đang tắt'
      return 'Đang khai'
    },
    renderExpectation(val) {
      if (!val) return ''
      if (val.clazz) return val.clazz
      if (val.school) return val.school
      return ''
    },
    renderTotalScoreG6(cv) {
      if (cv.type === 'Khối 6') {
        const studentProfile = Number(get(cv, 'studyRecord.totalMathLiterature', 0))
        const priority = Number(get(cv, 'ltvExamResult.priorityMark', 0))
        let examMath = Number(get(cv, 'ltvExamResult.examMathMark', 0))
        let examLiterature = Number(get(cv, 'ltvExamResult.examLiterature', 0))
        let examEnglish = Number(get(cv, 'ltvExamResult.examEnglish', 0))
        if (isNaN(examMath)) examMath = 0
        if (isNaN(examLiterature)) examLiterature = 0
        if (isNaN(examEnglish)) examEnglish = 0
        return ((examMath + examLiterature + examEnglish) * 2 + studentProfile + priority).toFixed(2)
      }
      return '---'
    },
    getGroupExpectationChildren(group, prefix = '') {
      if (Array.isArray(group) && group.length) return prefix + group.join(', ')
      return ''
    },
    getGroupExpectation(expectation) {
      let result = []
      const childKHXH = this.getGroupExpectationChildren(get(expectation, 'groupKHXH', []), '- KHXH: ')
      const childKHTN = this.getGroupExpectationChildren(get(expectation, 'groupKHTN', []), '- KHTN: ')
      const childCNNT = this.getGroupExpectationChildren(get(expectation, 'groupCNNT', []), '- CNNT: ')
      if (childKHXH.length) result.push(childKHXH)
      if (childKHTN.length) result.push(childKHTN)
      if (childCNNT.length) result.push(childCNNT)
      if (result.length) return result.join(`\n`)
      return '---'
    },
    renderGroupExpectationG10(cv) {
      if (cv.type === 'Khối 10') {
        let NV1 = this.getGroupExpectation(get(cv, 'ltvExamResult.groupExpectation1'))
        let NV2 = this.getGroupExpectation(get(cv, 'ltvExamResult.groupExpectation2'))
        if (NV1 !== '---') NV1 = '\n' + NV1
        if (NV2 !== '---') NV2 = '\n' + NV2
        return `Nguyện vọng 1: ${NV1}\nNguyện vọng 2: ${NV2}`
      }
      return ''
    },
    renderTransDetail(cv) {
      const transCode = get(cv, 'activeCodeTransaction.transactionCode', '')
      const transId = get(cv, 'activeCodeTransaction.transactionId', '')

      return {transCode, transId}
    },
    async onExport() {
      this.$loading.active = true
      const isUserAdminBoth = this.$helpers.ALLOWED_VIEW_DETAIL_TRANS_SCHOLARSHIP.includes(this.user.id)
      const cvs = await this.fetchCVsIndependent({_start: 0, _limit: -1, populates: 'activeCodeTransaction'})
      const worksheet = XLSX.utils.json_to_sheet(
        cvs.map(cv => {
          const res = {
            'Mã hồ sơ': cv.code,
            'Trạng thái': this.renderCvStatus(cv.status),
            Khối: cv.type.slice(5),
            'Tạo lúc': moment(cv.createdAt).format('DD/MM/YYYY HH:mm:ss'),
            'Cập nhật lúc': moment(cv.updatedAt).format('DD/MM/YYYY HH:mm:ss'),
            'Tài khoản kích hoạt': cv.parentUsername,
            'Cơ sở': cv.department === 'unset' ? 'Chưa có thông tin' : cv.department,
            // 
            'Họ tên học sinh': cv.name,
            'Ngày sinh': cv.dob ? moment(cv.dob, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
            'Giới tính': cv.gender === 'female' ? 'Nữ' : 'Nam',
            'Mã học sinh (do Bộ GD&ĐT cấp)': cv.studentId,
            'Trường từng học': cv.school,
            //
            'Họ tên NGH': get(cv, 'parentName', ''),
            'Mối quan hệ với HS': get(cv, 'parentRelation', ''),
            'SDT NGH': get(cv, 'parentPhone', ''),
            'CCCD NGH': get(cv, 'parentResidentID', ''),
            'Email NGH': get(cv, 'parentEmail', ''),
            //
            'Nguyện vọng 1': this.renderExpectation(cv.expectation1),
            'Nguyện vọng 2': this.renderExpectation(cv.expectation2),
            'Nguyện vọng 3': this.renderExpectation(cv.expectation3),
            //
            'Thành tích nổi bật': get(cv, 'studyRecord.achievements', ''),
            'Diện tuyển thẳng (Khối 10)': get(cv, 'studyRecord.recuitingStraightType', ''),
            'Nguyện vọng Ban (Khối 10)': 'TODO',
            'Số báo danh dự thi': get(cv, 'ltvExamResult.studentExamID', ''),
            'Điểm thi Toán': get(cv, 'ltvExamResult.examMath') || get(cv, 'ltvExamResult.examMathMark'),
            'Điểm thi Văn': get(cv, 'ltvExamResult.examLiterature'),
            'Điểm thi Anh': get(cv, 'ltvExamResult.examEnglish'),
            'Điểm ưu tiên (Khối 6)': get(cv, 'ltvExamResult.priorityMark'),
            'Tổng điểm (khối 6)': this.renderTotalScoreG6(cv),
            'Tổng điểm (khối 10)': get(cv, 'ltvExamResult.entranceMark'),
            'Kết quả trúng tuyển': get(cv, 'ltvExamResult.passExamText'),
          }
          if (isUserAdminBoth) {
            const {transCode, transId} = this.renderTransDetail(cv)
            res['Mã tài khoản nhận tiền'] = transCode
            res['Mã tham chiếu giao dịch'] = transId
          }
          return res
        })
      )
      const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']}
      const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
      const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
      saveAs(data, 'ho-so.xlsx')
      this.$loading.active = false
    },
  },
}
</script>
